import React, {useEffect, useState, useRef, useCallback} from 'react'

import { Container } from 'react-bootstrap'

import FilterHotels from 'components/Safra/FilterResult'
import SearchBarHotels from 'components/Safra/SearchBarHotels'
import { NotFoundResultsHotel } from "components/Safra/NotFoundResults";
import { BoxHotel } from "components/Safra/BoxHotel";
import { LoaderSearchImage } from "components/Safra/Loader";
import Footer from 'components/Safra/Footer';

import {isChannel} from "utils";

import { getHotels } from "_services/hotels.service";
import { useApp } from "contexts/AppContext";
import { setHotelsListAction } from "../../../contexts/reducers/hotels/actions";
import { trackHotelRedoSearch, trackHotelSearch, trackHotelCallback } from "../../../utils/analytics";
import {
    getSafraHotelsFilter,
    getSafraHotelsOrder,
    setSafraHotelsFilter,
    setSafraHotelsOrder
} from "../../../utils/safraHotelsSearchState";
import format from "date-fns/format";

import "./paginationStyle.css"
import {useGenialApp} from "../../../contexts/GenialAppContext";


export default function HotelsSearchResult() {
    const [loading, setLoading] = useState(false)
    const [initialLoading, setInitialLoading] = useState(true);
    const [info, setInfo] = useState(true)
    const [data, setHotels] = useState([])
    const [totalItems, setTotalItems] = useState(0)
    const [filter, setFilter] = useState(() => getSafraHotelsFilter())
    const [order, setOrder] = useState(() => getSafraHotelsOrder())

    const { hotelState, hotelDispatch } =  !isChannel('genial') ? useApp() : useGenialApp()
    const { datesSearchHotel, locationSearchHotel, guestsSearchHotel, hotelNameSearch } = hotelState

    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [filterData, setFilterData] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isAtBottom, setIsAtBottom] = useState(false);
    const n = 10
    
    const loadingRef = useRef(null);
    const prefetchRef = useRef(null);

    const loadMoreHotels = useCallback(() => {
        if (loading || !hasMore) return;
        setCurrentPage(prevPage => prevPage + 1);
    }, [loading, hasMore]);

    useEffect(() => {
        const prefetchObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMoreHotels();
            }
        }, { threshold: 0.1 });

        const loadingObserver = new IntersectionObserver((entries) => {
            setIsAtBottom(entries[0].isIntersecting);
        }, { threshold: 0.1 });

        if (prefetchRef.current) prefetchObserver.observe(prefetchRef.current);
        if (loadingRef.current) loadingObserver.observe(loadingRef.current);

        return () => {
            prefetchObserver.disconnect();
            loadingObserver.disconnect();
        };
    }, [loadMoreHotels, filterData]);

    async function searchHotels(firstPage = false) {
        if (locationSearchHotel?.id) {
            if (loading && currentPage > 1) return;
            if (!hasMore && currentPage > 1) {
                setLoading(false);
                return;
            }

            if (currentPage === 1) {
                setInitialLoading(true);
            }
            setLoading(true);

            const searchParams = {
                location: locationSearchHotel.label || locationSearchHotel.name,
                search_name: hotelNameSearch?.name?.trim() || '',
                check_in: datesSearchHotel.startDate ? format(datesSearchHotel.startDate, "dd/MM/yyyy") : '',
                check_out: datesSearchHotel.endDate ? format(datesSearchHotel.endDate, "dd/MM/yyyy") : '',
                nights: datesSearchHotel.days,
                hosts: guestsSearchHotel.adults + guestsSearchHotel.children,
                adults: guestsSearchHotel.adults,
                children: guestsSearchHotel.children
            };

            if (firstPage) {
                trackHotelRedoSearch();
                trackHotelSearch(searchParams);
                handleNewSearch();
                return;
            }
            
            const response = await getHotels(
                currentPage,
                guestsSearchHotel,
                datesSearchHotel,
                locationSearchHotel,
                filter,
                order,
                hotelNameSearch?.name
            );

            if (!response.status) {
                if (currentPage === 1) {
                    setHotels([]);
                    trackHotelCallback({
                        status: 'erro',
                        action: 'busca',
                        error: response.message || 'Erro ao buscar hotéis'
                    });
                }
                setHasMore(false);
                setTotalItems(0);
                setLoading(false);
                setInitialLoading(false);
                return;
            }

            if (response.status && response.data?.hotels) {
                const newHotels = response.data.hotels;
                
                if (currentPage === 1) {
                    setHotels(newHotels);
                    hotelDispatch(setHotelsListAction(newHotels));
                    if (newHotels.length > 0) {
                        trackHotelCallback({
                            status: 'sucesso',
                            action: 'busca'
                        });
                    } else {
                        trackHotelCallback({
                            status: 'sucesso',
                            action: 'busca',
                            error: 'hotéis não encontrados'
                        });
                    }
                } else {
                    setHotels(prev => [...prev, ...newHotels]);
                }
                
                setTotalItems(response.data.totalFound);
                setHasMore(newHotels.length > 0 && (currentPage * 10) < response.data.totalFound);
            }

            setLoading(false);
            if (currentPage === 1) {
                setInitialLoading(false);
            }
            setInfo(true);
            getBodyHeight();
        }
    }

    const handleNewSearch = () => {
        setHotels([]);
        setFilterData([]);
        setCurrentPage(1);
        setHasMore(true);
        setRefreshKey(prev => prev + 1);
        
        // Scroll to top of page
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        searchHotels();
    }, [currentPage, filter, order, refreshKey]);

    useEffect(() => {
        setSafraHotelsFilter(filter)
    }, [filter])

    useEffect(() => {
        setSafraHotelsOrder(order)
    }, [order])

    const getBodyHeight = () => {
        setTimeout(function () {
            const elemento = document.getElementById('result-content')

            if (elemento) {
                window.parent.postMessage(elemento.offsetHeight, "*");
            }
        }, 500)
    }

    const handleApplyOrder = (orderFilter) => {
        setOrder(orderFilter)
        handleNewSearch();
    }

    const handleInfo = () => {
        setInfo(!info)
    }

    useEffect(() => {
        if (!data || data.length === 0) {
            setFilterData([]);
            return;
        }
        setFilterData(data);
    }, [data]);

    useEffect(() => {
        // Scroll to top when initial loading is done
        if (!initialLoading) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [initialLoading]);

    if (initialLoading) return <LoaderSearchImage />

    return (
        <>
            <div className="bg-white">
                <SearchBarHotels
                    info={info}
                    handleInfo={handleInfo}
                    searchHotels={() => searchHotels(true)}
                />
                <Container>
                    <div className="filter-content">
                        <FilterHotels
                            handleApplyOrder={handleApplyOrder}
                            order={order}
                        />
                    </div>
                </Container>
            </div>

            <Container className="mt-5">
                <div id="result-content" className="result-content">
                    { !filterData?.length && !loading &&
                        <NotFoundResultsHotel handleInfo={handleInfo} />
                    }

                    { filterData?.length > 0 &&
                        filterData.map((hotel, index) => {
                            const isPrefetchTrigger = index === filterData.length - 5;
                            return (
                                <div key={index} ref={isPrefetchTrigger ? prefetchRef : null}>
                                    <BoxHotel data={hotel} id={index} />
                                </div>
                            )
                        })
                    }
                </div>

                {loading && isAtBottom && <LoaderSearchImage />}
                <div ref={loadingRef} style={{ height: '20px', width: '100%' }}></div>
                
            </Container>
            <Footer />
        </>
    )
}
